<ul class="agpr-imageList">
    <li
        *ngFor="let image of _images; let i = index;"
        class="agpr-imageList-item"
        [ngClass]="{'agpr-imageList-item-hasError': image.error}"
    >
        <div
            *ngIf="showPopover && image && !image.error"
            [agprPopover]="imagePopover"
            [popoverOpenDelay]="75"
            [popoverOffsetTop]="0"
            [popoverZIndex]="2"
        >
            @if (showPreferredImageButton) {
                <button
                    class="agpr-imageList-button"
                    [ngClass]="{'agpr-imageList-button--preferred': image.isPreferred}"
                    [agprTooltip]="!image.isPreferred && 'imageList.setAsPreferred'"
                    tooltipPosition="right"
                    (click)="handlePreferredImageChange(image)"
                    [disabled]="image.isPreferred"
                >
                    <span
                        role="image"
                        [class]="image.isPreferred ? 'fa-solid fa-star' : 'fa-regular fa-star'"
                    ></span>
                </button>
            }
            <img
                class="agpr-imageList-image"
                [src]="image.source"
                (error)="imageFailed(image)"
                (load)="onImageLoad()"
                alt=""
            />
            <div
                *ngIf="_matches[i]?.count === 1"
                class="agpr-imageList-primaryKeyword"
            >
                <span class="agpr-imageList-bestMatch">
                    {{ _matches[i].best }}
                </span>
            </div>
            <div
                *ngIf="_matches[i]?.count > 1"
                class="agpr-imageList-primaryKeyword"
            >
                <span class="agpr-imageList-bestMatch">
                    {{ _matches[i].best }}
                </span>
                &nbsp;{{
                    'imageList.primarySearchTermAndXMore' | localize: {
                        additionalCount: _matches[i]?.count -1
                    }
                }}
            </div>
            <ng-template #imagePopover styleClass>
                <div class="agpr-imageList-imageDetails">
                    <img
                        class="agpr-imageList-image agpr-imageList-image--expanded"
                        [src]="image.source"
                        alt=""
                    />
                    <div
                        *ngIf="image.metadata.keywords.length > 0"
                        class="agpr-imageList-imageMetadata"
                    >
                        <agpr-scroll-panel>
                            <ul
                                *ngIf="image.metadata.keywords.length > 0"
                                class="agpr-imageList-metadataList"
                            >
                                <li
                                    *ngFor="let metadataItem of image.metadata.keywords"
                                    class="agpr-imageList-metadataItem"
                                    [innerHTML]="metadataItem.description | highlightKeywords: _highlightKeywords"
                                ></li>
                            </ul>
                        </agpr-scroll-panel>
                    </div>
                </div>
            </ng-template>
        </div>
        <div *ngIf="!showPopover && !image.error">
            <img
                class="agpr-imageList-image"
                alt=""
                [src]="image.source"
                (error)="imageFailed(image)"
            />
        </div>
        <ng-container *ngIf="image.error">
            <ng-container *ngIf="hasImageErrorTemplate">
                <ng-container *ngTemplateOutlet="imageErrorTemplate"></ng-container>
            </ng-container>
            <div *ngIf="!hasImageErrorTemplate"
                [ngClass]="{
                    'agpr-imageList-imageFailedMessage': !useMentionCardErrorStyle,
                    'agpr-imageList-imageFailedMessageCustom': useMentionCardErrorStyle
                }">
                <agpr-message
                    [severity]="messageSeverities.noContent"
                    [icon]="useMentionCardErrorStyle ? 'fa-duotone fa-regular fa-file-xmark' : 'fa-duotone fa-light fa-file-xmark'"
                >
                    <div>{{ localization.imageNoLongerAvailable }}</div>
                </agpr-message>
            </div>
        </ng-container>
    </li>
</ul>
